module.exports = require("eris");


//////////////////
// WEBPACK FOOTER
// external "eris"
// module id = 8
// module chunks = 0